import SearchEmptyState from './SearchEmptyState';
import SearchEmptyStateContainer, {
  OwnProps,
} from './SearchEmptyState.container';

export default SearchEmptyStateContainer(
  SearchEmptyState
) as React.ComponentClass<OwnProps>;
